module.exports = __webpack_public_path__ + "static/media/gc-paid.1548aaa4.svg";